export { types as pageTypes } from './actions/pages';

export const CHECK_AUTH = 'CHECK_AUTH';
export const SET_BUILDING_ID = 'SET_BUILDING_ID';
export const SET_SITE_SAVED_STATUS = 'SET_SITE_SAVED_STATUS';

export const EXPORT_FILES_REQUEST = 'EXPORT_FILES_REQUEST';
export const EXPORT_FILES_SUCCESS = 'EXPORT_FILES_SUCCESS';
export const EXPORT_FILES_FAILURE = 'EXPORT_FILES_FAILURE';
// Clear Messages
export const USER_CLEAR_MESSAGE = 'USER_CLEAR_MESSAGE';
export const SITE_CLEAR_MESSAGE = 'SITE_CLEAR_MESSAGE';

export const PROFILE_SITES_REQUEST = 'PROFILE_SITES_REQUEST';
export const PROFILE_SITES_SUCCESS = 'PROFILE_SITES_SUCCESS';
export const PROFILE_SITES_FAILURE = 'PROFILE_SITES_FAILURE';

export const FETCH_SITE_REQUEST = 'FETCH_SITE_REQUEST';
export const FETCH_SITE_SUCCESS = 'FETCH_SITE_SUCCESS';
export const FETCH_SITE_FAILURE = 'FETCH_SITE_FAILURE';

export const DELETE_SITE_REQUEST = 'DELETE_SITE_REQUEST';
export const DELETE_SITE_SUCCESS = 'DELETE_SITE_SUCCESS';
export const DELETE_SITE_FAILURE = 'DELETE_SITE_FAILURE';

export const SAVE_SITE_REQUEST = 'SAVE_SITE_REQUEST';
export const SAVE_SITE_SUCCESS = 'SAVE_SITE_SUCCESS';
export const SAVE_SITE_FAILURE = 'SAVE_SITE_FAILURE';

export const EXPORT_JSON_REQUEST = 'EXPORT_JSON_REQUEST';
export const EXPORT_JSON_SUCCESS = 'EXPORT_JSON_SUCCESS';
export const EXPORT_JSON_FAILURE = 'EXPORT_JSON_FAILURE';

export const CONFIG_DOMAIN_REQUEST = 'CONFIG_DOMAIN_REQUEST';
export const CONFIG_DOMAIN_SUCCESS = 'CONFIG_DOMAIN_SUCCESS';
export const CONFIG_DOMAIN_FAILURE = 'CONFIG_DOMAIN_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const LOGIN_WITH_REQUEST = 'LOGIN_WITH_REQUEST';
export const LOGIN_WITH_SUCCESS = 'LOGIN_WITH_SUCCESS';
export const LOGIN_WITH_FAILURE = 'LOGIN_WITH_FAILURE';

export const DUPLICATE_SITE_REQUEST = 'DUPLICATE_SITE_REQUEST';
export const DUPLICATE_SITE_SUCCESS = 'DUPLICATE_SITE_SUCCESS';
export const DUPLICATE_SITE_FAILURE = 'DUPLICATE_SITE_FAILURE';

export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';

export const GET_ALL_USERS_REQUEST = 'GET_ALL_USERS_REQUEST';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAILURE = 'GET_ALL_USERS_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const GET_TEMPLATE_REQUEST = 'GET_TEMPLATE_REQUEST';
export const GET_TEMPLATE_SUCCESS = 'GET_TEMPLATE_SUCCESS';
export const GET_TEMPLATE_FAILURE = 'GET_TEMPLATE_FAILURE';

export const MAKE_TEMPLATE_REQUEST = 'MAKE_TEMPLATE_REQUEST';
export const MAKE_TEMPLATE_SUCCESS = 'MAKE_TEMPLATE_SUCCESS';
export const MAKE_TEMPLATE_FAILURE = 'MAKE_TEMPLATE_FAILURE';

export const GET_TEMPLATES_REQUEST = 'GET_TEMPLATES_REQUEST';
export const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS';
export const GET_TEMPLATES_FAILURE = 'GET_TEMPLATES_FAILURE';

export const REFRESH_AT_REQUEST = 'REFRESH_AT_REQUEST';
export const REFRESH_AT_SUCCESS = 'REFRESH_AT_SUCCESS';
export const REFRESH_AT_FAILURE = 'REFRESH_AT_FAILURE';

export const SOCIAL_LOGIN_REQUEST = 'SOCIAL_LOGIN_REQUEST';
export const SOCIAL_LOGIN_SUCCESS = 'SOCIAL_LOGIN_SUCCESS';
export const SOCIAL_LOGIN_FAILURE = 'SOCIAL_LOGIN_FAILURE';

export const SAVE_ELEMENT_REQUEST = 'SAVE_ELEMENT_REQUEST';
export const SAVE_ELEMENT_SUCCESS = 'SAVE_ELEMENT_SUCCESS';
export const SAVE_ELEMENT_FAILURE = 'SAVE_ELEMENT_FAILURE';

export const GET_PROVIDED_ELEMENT_REQUEST = 'GET_PROVIDED_ELEMENT_REQUEST';
export const GET_PROVIDED_ELEMENT_SUCCESS = 'GET_PROVIDED_ELEMENT_SUCCESS';
export const GET_PROVIDED_ELEMENT_FAILURE = 'GET_PROVIDED_ELEMENT_FAILURE';

export const GET_SAVED_ELEMENT_REQUEST = 'GET_SAVED_ELEMENT_REQUEST';
export const GET_SAVED_ELEMENT_SUCCESS = 'GET_SAVED_ELEMENT_SUCCESS';
export const GET_SAVED_ELEMENT_FAILURE = 'GET_SAVED_ELEMENT_FAILURE';

export const REMOVE_ELEMENT_REQUEST = 'REMOVE_ELEMENT_REQUEST';
export const REMOVE_ELEMENT_SUCCESS = 'REMOVE_ELEMENT_SUCCESS';
export const REMOVE_ELEMENT_FAILURE = 'REMOVE_ELEMENT_FAILURE';

// MEMBERSHIP
export const UPDATE_MEMBERSHIP_REQUEST = 'UPDATE_MEMBERSHIP_REQUEST';
export const UPDATE_MEMBERSHIP_SUCCESS = 'UPDATE_MEMBERSHIP_SUCCESS';
export const UPDATE_MEMBERSHIP_FAILURE = 'UPDATE_MEMBERSHIP_FAILURE';

export const UPDATE_MEMBERSHIP_INFO_REQUEST = 'UPDATE_MEMBERSHIP_INFO_REQUEST';
export const UPDATE_MEMBERSHIP_INFO_SUCCESS = 'UPDATE_MEMBERSHIP_INFO_SUCCESS';
export const UPDATE_MEMBERSHIP_INFO_FAILURE = 'UPDATE_MEMBERSHIP_INFO_FAILURE';

export const FETCH_MEMBERSHIP_REQUEST = 'FETCH_MEMBERSHIP_REQUEST';
export const FETCH_MEMBERSHIP_SUCCESS = 'FETCH_MEMBERSHIP_SUCCESS';
export const FETCH_MEMBERSHIP_FAILURE = 'FETCH_MEMBERSHIP_FAILURE';
